import React from "react";
import { Box } from "@metrea-ui/v2";

/**
 * Shared modal content shell for viewport positioning, size limits, and scroll
 * containment. Dialog open/close behavior stays with the caller.
 */
export const ModalShell = ({
	children,
	inset = "5%",
	zIndex = 1400,
	bg = "white",
	px = 16,
	py = 12,
	contentOverflowY = "auto",
	...rest
}) => {
	return (
		<Box position="fixed" inset={inset} bg={bg} boxShadow="lg" zIndex={zIndex} {...rest}>
			<Box height="100%" overflowY={contentOverflowY} px={px} py={py}>
				{children}
			</Box>
		</Box>
	);
};
